import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import SEO from '../components/SEO';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-[#0d0d0d] text-white">
      <SEO
        title="Contact - Koby Pierce"
        description="Get in touch with Koby Pierce for business inquiries, collaborations, or just to say hello. I'm always interested in discussing new opportunities and innovative projects."
        keywords="Contact Koby Pierce, Business Inquiries, Collaboration, Hybrid Hosting Contact, UpPacket Contact"
        url="https://kobypierce.com/contact"
      />
      <Header />

      {/* Main container with proper spacing */}
      <div className="w-full md:w-2/3 mx-auto pt-24 pb-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Let's Connect</h1>
          <p className="text-gray-300 text-lg">
            I'm always interested in discussing new opportunities, innovative projects, or just having a great conversation about technology.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Form */}
          <div>
            <ContactForm />
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-[#1a1a1a] p-6 rounded-lg border border-[#4d4d4d]">
              <h3 className="text-xl font-bold mb-4">How I Can Help You</h3>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="p-2 bg-blue-600 rounded-lg mt-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Reliable Cloud Infrastructure</h4>
                    <p className="text-gray-400 text-sm">
                      Through Hybrid Hosting, I provide dependable hosting solutions that scale with your business needs.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="p-2 bg-green-600 rounded-lg mt-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Internet Access Solutions</h4>
                    <p className="text-gray-400 text-sm">
                      PTP installations, security cameras, routers, Starlink setups, and network infrastructure that connects communities.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="p-2 bg-orange-600 rounded-lg mt-1">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Industry-Specific Tools</h4>
                    <p className="text-gray-400 text-sm">
                      Building authentic solutions for specific industries, like BarnBills for the horse community, where I truly care about the problems I'm solving.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 p-6 rounded-lg border border-blue-700/50">
              <h3 className="text-xl font-bold mb-3">My Mission</h3>
              <p className="text-blue-100 text-sm mb-3">
                I believe in creating a world of peace through sustainable abundance and exploring the stars. 
                Technology should push humanity forward, creating products people truly love while building a more peaceful Earth.
              </p>
              <div className="flex items-center space-x-2 text-sm text-blue-200">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span>Authentic work that serves humanity's highest aspirations</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer container with 2/3 width */}
      <div className="w-full md:w-2/3 mx-auto">
        <Footer />
      </div>
      
      {/* Extra bottom padding */}
      <div className="pb-8"></div>
    </div>
  );
};

export default ContactPage; 